import Entete from "./Entete";
export default Entete;
